import type { ShowEventType } from '@api';
import type { ScheduleEventData } from '@mantine/schedule';
import dayjs from 'dayjs';
import type { PayloadType } from '../../../../types';

type GetScheduledEventFromShowsDataReturnType =
  ScheduleEventData<PayloadType>[];

export const getScheduledEventFromShowsData = (
  records: ShowEventType[]
): GetScheduledEventFromShowsDataReturnType => {
  return records.map((show) => ({
    id: `show-${show.show.artist.id}-${show.show.tour.id}-${show.show.showDate}`,
    title: `${show.show.artist.name} | ${show.show.tour.name}`,
    start: dayjs(show.show.showDate).format('YYYY-MM-DD 00:00:00'),
    end: dayjs(show.show.showDate).add(1, 'day').format('YYYY-MM-DD 00:00:00'),
    color: '#006400',
    payload: {
      type: 'SHOW',
      show,
    },
  }));
};
